import { createRoutine } from 'redux-saga-routines';

export const updateSegmentFilter = createRoutine('UPDATE_SEGMENT_LOGIC');
export const deleteSegmentSequence = createRoutine('DELETE_SEGMENT_LOGIC');
export const updateSegmentSequence = createRoutine('UPDATE_SEGMENT_SEQUENCE');
export const addNewSequence = createRoutine('ADD_NEW_SEGMENT_SEQUENCE');
export const addNestedSequence = createRoutine(
  'ADD_NEW_NESTED_SEGMENT_SEQUENCE'
);
export const resetContactListData = createRoutine('RESET_CONTACT_LIST_DATA');
export const resetAccountListData = createRoutine('RESET_ACCOUNT_LIST_DATA');
export const resetOrganizationListData = createRoutine(
  'RESET_ORGANIZATION_LIST_DATA'
);
export const resetPipelineListData = createRoutine('RESET_PIPELINE_LIST_DATA');
export const getEntities = createRoutine('GET_ENTITIES');
export const clearSegmentState = createRoutine('CLEAR_SEGMENT_STATE');
export const clearSegmentListState = createRoutine('CLEAR_SEGMENT_LIST_STATE');
export const createEditSegment = createRoutine('CREATE_SEGMENT');
export const selectSegment = createRoutine('SELECT_SEGMENT');
export const pinSegment = createRoutine('PIN_SEGMENT');
export const resetSegmentResult = createRoutine('RESET_SEGMENT_RESULT');
export const createSegmentV2 = createRoutine('CREATE_SEGMENT');
export const deleteSegment = createRoutine('DELETE_SEGMENT');
export const updateSegment = createRoutine('UPDATE_SEGMENT');
export const fetchSegments = createRoutine('FETCH_SEGMENTS');
export const fetchSegmentResultsByIds = createRoutine(
  'FETCH_SEGMENTS_RESULTS_BY_IDS'
);
export const fetchSegmentById = createRoutine('FETCH_SEGMENT_BY_ID');
export const fetchSegmentData = createRoutine('FETCH_SEGMENT_DATA');
export const filterBySegment = createRoutine('FILTER_BY_SEGMENT');
export const updateSelectedSegment = createRoutine('UPDATE_SELECTED_SEGMENT');
export const fetchSelectedSegmentResults = createRoutine(
  'FETCH_SELECTED_SEGMENT_RESULTS'
);

export const fetchActivityTypes = createRoutine('FETCH_ACTIVITY_TYPES');
export const fetchActivityTypesLookup = createRoutine(
  'FETCH_ACTIVITY_TYPES_LOOKUP'
);
export const createActivityType = createRoutine('CREATE_ACTIVITY_TYPES');
export const editActivityType = createRoutine('EDIT_ACTIVITY_TYPES');
export const changeActivityTypeActiveStatus = createRoutine(
  'ACTIVATE_DEACTIVATE_ACTIVITY_TYPES'
);

export const fetchFieldDefinitions = createRoutine('FETCH_FIELD_DEFINITIONS');
export const addSelectedColumn = createRoutine('ADD_SELECTED_COLUMN');
export const removeSelectedColumn = createRoutine('REMOVE_SELECTED_COLUMN');
export const removeAllSelectedColumn = createRoutine(
  'REMOVE_ALL_SELECTED_COLUMN'
);
export const reorderColumns = createRoutine('REORDER_COLUMNS');
export const saveSelectedColumns = createRoutine('SAVE_SELECTED_COLUMN');

export const getPartialPipelinesList = createRoutine(
  'FETCH_PARTIAL_PIPELINES_LIST'
);
export const getPartialCustomObjectInstanceList = createRoutine(
  'FETCH_PARTIAL_CUSTOM_OBJECT_INSTANCE_LIST'
);

export const setMyEntitiesOnly = createRoutine('SET_MY_ENTITIES_ONLY');
export const bulkUploadEntity = createRoutine('BULK_UPLOAD_ENTITY');
export const getBulkUploadHistory = createRoutine('BULK_UPLOAD_ENTITY_HISTORY');
export const bulkEditEntity = createRoutine('BULK_EDIT_ENTITY');
export const getUploadErrorReport = createRoutine('BULK_UPLOAD_ERROR_REPORT');
export const bulkPulseUpdate = createRoutine('BULK_UPDATE_PULSE_LOG');
export const bulkChurnEntity = createRoutine('BULK_CHURN_ENTITY');

export const accountFetchData = createRoutine('ACCOUNT_FETCH_DATA');
export const accountFetchStatbarData = createRoutine(
  'ACCOUNT_FETCH_STAT_BAR_DATA'
);

export const fetchAccountDataById = createRoutine('FETCH_ACCOUNT_DATA_BY_ID');
export const accountArchive = createRoutine('ACCOUNT_ARCHIVE');
export const accountRestore = createRoutine('ACCOUNT_RESTORE');
export const accountChurn = createRoutine('ACCOUNT_CHURN');
export const toggleAccountForm = createRoutine('TOGGLE_ACCOUNT_FORM');
export const createAccount = createRoutine('CREATE_ACCOUNT');
export const editAccount = createRoutine('EDIT_ACCOUNT');
export const updateAccountField = createRoutine('UPDATE_ACCOUNT_FIELD');
export const assignOrganization = createRoutine(
  'ASSIGN_ORGANIZATION_TO_ACCOUNT'
);

export const organizationFetchData = createRoutine('ORGANIZATION_FETCH_DATA');
export const organizationFetchStatbarData = createRoutine(
  'ORGANIZATION_FETCH_STAT_BAR_DATA'
);
export const fetchOrganizationDataById = createRoutine(
  'FETCH_ORGANIZATION_DATA_BY_ID'
);
export const organizationArchive = createRoutine('ORGANIZATION_ARCHIVE');
export const organizationRestore = createRoutine('ORGANIZATION_RESTORE');
export const organizationChurn = createRoutine('ORGANIZATION_CHURN');
export const toggleOrganizationForm = createRoutine('TOGGLE_ORGANIZATION_FORM');
export const createOrganization = createRoutine('CREATE_ORGANIZATION');
export const editOrganization = createRoutine('EDIT_ORGANIZATION');
export const updateOrganizationField = createRoutine(
  'UPDATE_ORGANIZATION_FIELD'
);

export const contactFetchData = createRoutine('CONTACT_FETCH_DATA');
export const contactFetchStatbarData = createRoutine(
  'CONTACT_FETCH_STAT_BAR_DATA'
);
export const fetchContactDataById = createRoutine('FETCH_CONTACT_DATA_BY_ID');
export const fetchContactDataByAccountId = createRoutine(
  'FETCH_CONTACT_DATA_BY_ACCOUNT_ID'
);
export const fetchContactDataByOrganizationId = createRoutine(
  'FETCH_CONTACT_DATA_BY_ORGANIZATION_ID'
);
export const contactArchive = createRoutine('CONTACT_ARCHIVE');
export const contactRestore = createRoutine('CONTACT_RESTORE');
export const toggleContactForm = createRoutine('TOGGLE_CONTACT_FORM');
export const createContact = createRoutine('CREATE_CONTACT');
export const editContact = createRoutine('EDIT_CONTACT');
export const updateContactField = createRoutine('UPDATE_CONTACT_FIELD');

export const productFetchData = createRoutine('PRODUCT_FETCH_DATA');
export const productFetchStatbarData = createRoutine(
  'PRODUCT_FETCH_STAT_BAR_DATA'
);
export const productDelete = createRoutine('PRODUCT_DELETE');
export const toggleProductForm = createRoutine('TOGGLE_PRODUCT_FORM');
export const createProduct = createRoutine('CREATE_PRODUCT');
export const editProduct = createRoutine('EDIT_PRODUCT');

export const pipelineFetchData = createRoutine('PIPELINE_FETCH_DATA');
export const pipelineFetchStatbarData = createRoutine(
  'PIPELINE_FETCH_STAT_BAR_DATA'
);
export const fetchPipelineDataById = createRoutine('FETCH_PIPELINE_DATA_BY_ID');
export const pipelineArchive = createRoutine('PIPELINE_ARCHIVE');
export const pipelineRestore = createRoutine('PIPELINE_RESTORE');
export const togglePipelineForm = createRoutine('TOGGLE_PIPELINE_FORM');
export const createPipeline = createRoutine('CREATE_PIPELINE');
export const editPipeline = createRoutine('EDIT_PIPELINE');

export const fetchFields = createRoutine('FETCH_FIELDS');
export const fetchFieldUsage = createRoutine('FETCH_FIELDS_USAGE');
export const deleteField = createRoutine('DELETE_FIELD');
export const toggleFieldForm = createRoutine('TOGGLE_FIELD_FORM');
export const createAttribute = createRoutine('CREATE_ATTRIBUTE');
export const editAttribute = createRoutine('EDIT_ATTRIBUTE');
export const fetchSystemFields = createRoutine('FETCH_SYSTEM_FIELDS');
export const editSystemFields = createRoutine('EDIT_SYSTEM_FIELDS');
export const reorderCustomAttributes = createRoutine(
  'REORDER_CUSTOM_ATTRIBUTES'
);

export const fetchFieldMappings = createRoutine('FETCH_FIELD_MAPPINGS');
export const updateFieldMappings = createRoutine('UPDATE_FIELD_MAPPINGS');

export const gmailLogin = createRoutine('GMAIL_LOGIN');
export const getGmailLogin = createRoutine('GET_GMAIL_LOGIN');
export const getEmails = createRoutine('GET_MAILS');
export const fetchFieldPins = createRoutine('FETCH_FIELD_PINS');
export const createFieldPin = createRoutine('CREATE_FIELD_PIN');
export const deleteFieldPin = createRoutine('DELETE_FIELD_PIN');
export const uploadFileInProgress = createRoutine('UPLOAD_FILE_IN_PROGRESS');

export const updateTableColumnDefinition = createRoutine(
  'UPDATE_TABLE_COLUMN_DEFINITION'
);

// entity-action
export const sendEmail = createRoutine('SEND_EMAIL');
export const replyToEmail = createRoutine('REPLY_EMAIL');
export const addNote = createRoutine('ADD_NOTE');
export const bookmarkNote = createRoutine('BOOKMARK_NOTE');
export const deleteNote = createRoutine('DELETE_NOTE');
export const updateNote = createRoutine('UPDATE_NOTE');
export const addActivity = createRoutine('ADD_ACTIVITY');
export const bookmarkActivity = createRoutine('BOOKMARK_ACTIVITY');
export const deleteActivity = createRoutine('DELETE_ACTIVITY');
export const updateActivity = createRoutine('UPDATE_ACTIVITY');
export const fetchActivityByEmailMessages = createRoutine(
  'FETCH_ACTIVITY_BY_EMAIL_MESSAGES'
);
export const markPulse = createRoutine('ADD_PULSE_LOG');
export const bookmarkPulse = createRoutine('BOOKMARK_PULSE_LOG');
export const deletePulse = createRoutine('DELETE_PULSE_LOG');
export const updatePulse = createRoutine('UPDATE_PULSE_LOG');

// File handling
export const uploadFile = createRoutine('UPLOAD_FILE');
export const uploadScopedFile = createRoutine('UPLOAD_SCOPED_FILE');
export const setFilesLength = createRoutine('SET_FILES_LENGTH');
export const setFiles = createRoutine('ADD_FILES');
export const setScopedFiles = createRoutine('ADD_SCOPED_FILES');
export const uploadFileMetaData = createRoutine('UPLOAD_FILE_META_DATA');
export const removeFile = createRoutine('REMOVE_FILE');
export const removeScopedFile = createRoutine('REMOVE_SCOPED_FILE');
export const downloadFile = createRoutine('DOWNLOAD_FILE');
export const editFile = createRoutine('EDIT_FILE');
export const bookmarkFiles = createRoutine('BOOKMARK_FILE');
export const deleteFiles = createRoutine('DELETE_FILE');
export const pinFile = createRoutine('PIN_FILE');

export const fetchNotes = createRoutine('FETCH_NOTES');
export const loadMoreNotes = createRoutine('LOAD_MORE_NOTES');
export const clearNotes = createRoutine('CLEAR_NOTES');
export const fetchEmail = createRoutine('FETCH_EMAILS');
export const fetchActivities = createRoutine('FETCH_ACTIVITIES');
export const loadMoreActivities = createRoutine('LOAD_MORE_ACTIVITIES');
export const clearActivities = createRoutine('CLEAR_ACTIVITIES');
export const refreshActivities = createRoutine('REFRESH_ACTIVITIES');
export const fetchPulseLogs = createRoutine('FETCH_PULSE_LOGS');
export const loadMorePulseLogs = createRoutine('LOAD_MORE_PULSE_LOGS');
export const clearPulse = createRoutine('CLEAR_PULSE');
export const refreshNotes = createRoutine('REFRESH_NOTES');
export const refreshPulse = createRoutine('REFRESH_PULSE');
export const fetchFiles = createRoutine('FETCH_FILES');
export const updateActivityFiles = createRoutine('UPDATE_ACTIVITY_FILES');
export const deleteActivityFiles = createRoutine('DELETE_ACTIVITY_FILES');
export const bookmarkActivityFiles = createRoutine('BOOKMARK_ACTIVITY_FILES');
export const fetchFilesTimeline = createRoutine('FETCH_FILES_TIMELINE');
export const fetchLoadMoreFiles = createRoutine('FETCH_LOAD_MORE_FILES');
export const refreshFiles = createRoutine('REFRESH_FILES');
export const clearFiles = createRoutine('CLEAR_FILES');
export const bookmarkSurvey = createRoutine('BOOKMARK_SURVEY_RESPONSE');
export const fetchSurveyResponsesByEntity = createRoutine(
  'FETCH_SURVEY_RESPONSES_BY_ENTITY'
);
export const clearSurveyResponsesByEntity = createRoutine(
  'CLEAR_SURVEY_RESPONSE_BY_ENTITY'
);

// auth
export const setUsername = createRoutine('SET_USERNAME');
export const logIn = createRoutine('LOG_IN');
export const ssoLogIn = createRoutine('SSO_LOG_IN');
export const logOut = createRoutine('LOG_OUT');
export const restoreSession = createRoutine('RESTORE_SESSION');
export const resetSession = createRoutine('RESET_SESSION');
export const completeNewPassword = createRoutine('COMPLETE_NEW_PASSWORD');
export const forgotPassword = createRoutine('FORGOT_PASSWORD');
export const forgotPasswordSubmit = createRoutine('FORGOT_PASSWORD_SUBMIT');
export const showCognitoChallenge = createRoutine('SHOW_COGNITO_CHALLENGE');
export const resetErrorMessage = createRoutine('RESET_ERROR_MESSAGE');
export const set2FAuthenticationModalVisibleStatus = createRoutine(
  'SET_2F_AUTHENTICATION_MODAL_VISIBLE_STATUS'
);
export const setAuthenticatorAppModalVisibleStatus = createRoutine(
  'SET_AUTHENTICATOR_APP_MODAL_VISIBLE_STATUS'
);
export const setAuthenticatorSMSModalVisibleStatus = createRoutine(
  'SET_AUTHENTICATOR_SMS_MODAL_VISIBLE_STATUS'
);
export const setSecurityDrawerVisibleStatus = createRoutine(
  'SET_SECURITY_DRAWER_VISIBLE_STATUS'
);
export const setupTOTP = createRoutine('SETUP_TOTP');
export const verifyTOTP = createRoutine('VERIFY_TOTP');
export const verifyMFA = createRoutine('VERIFY_MFA');
export const setupMobile = createRoutine('SETUP_MOBILE');
export const resendMobileVerificationCode = createRoutine(
  'RESEND_MOBILE_VERIFICATION_CODE'
);
export const resendMobileMFACode = createRoutine('RESEND_MOBILE_MFA_CODE');
export const verifyMobile = createRoutine('VERIFY_MOBILE');
export const setSetupMobileStep = createRoutine('SET_SETUP_MOBILE_STEP');

export const disableMFA = createRoutine('DISABLE_MFA');
export const getPreferredMFA = createRoutine('GET_PREFERRED_MFA');
export const getHelpJuiceSSOToken = createRoutine('GET_HELP_JUICE_SSO_TOKEN');

// user profile
export const fetchCurrentUser = createRoutine('FETCH_CURRENT_USER');
export const updateCurrentUser = createRoutine('UPDATE_CURRENT_USER');
export const updateProfileWizardActiveKey = createRoutine(
  'UPDATE_PROFILE_WIZARD_ACTIVE_KEY'
);
export const fetchConnectHashedEmail = createRoutine(
  'FETCH_CONNECT_HASHED_EMAIL'
);

// users management // TODO : evaluate and remove unwanted actions
export const createUser = createRoutine('CREATE_USER');
export const fetchUsers = createRoutine('FETCH_USERS');
export const previewUsers = createRoutine('PREVIEW_USERS');
export const setUserManagementModelState = createRoutine(
  'SET_USER_MANAGEMENT_MODEL_STATE'
);
export const setSelectedUsers = createRoutine('SET_SELECTED_USERS');
export const updatePreviewUserRole = createRoutine('UPDATE_PREVIEW_USER_ROLE');

export const inviteUsers = createRoutine('INVITE_USERS');
export const updateUser = createRoutine('UPDATE_USER');

export const updateUserStatus = createRoutine('UPDATE_USER_STATUS');
export const disableUserMFA = createRoutine('DISABLE_USER_MFA');
export const resendUserInvitation = createRoutine('RESEND_USER_INVITATION');

export const setInviteUsersPanelVisibleStatus = createRoutine(
  'SET_INVITE_USERS_PANEL_VISIBLE_STATUS'
);
export const setEditUserInfoPanelVisibleStatus = createRoutine(
  'SET_EDIT_USER_INFO_PANEL_VISIBLE_STATUS'
);
export const setEditUserRolePanelVisibleStatus = createRoutine(
  'SET_EDIT_USER_ROLE_PANEL_VISIBLE_STATUS'
);

export const setDeactivateUserModelVisibleStatus = createRoutine(
  'SET_DEACTIVATE_USER_MODEL_VISIBLE_STATUS'
);

export const setReactivateUserModelVisibleStatus = createRoutine(
  'SET_REACTIVATE_USER_MODEL_VISIBLE_STATUS'
);

export const setResendInvitationModelVisibleStatus = createRoutine(
  'SET_RESEND_INVITATION_MODEL_VISIBLE_STATUS'
);

export const setRevokeInvitationModelVisibleStatus = createRoutine(
  'SET_REVOKE_INVITATION_MODEL_VISIBLE_STATUS'
);

export const setDisableMFAModelVisibleStatus = createRoutine(
  'SET_DISABLE_MFA_MODEL_VISIBLE_STATUS'
);
//

export const setUserProfileVisibleStatus = createRoutine(
  'SET_USER_PROFILE_VISIBLE_STATUS'
);

// currency
export const fetchActiveCurrencies = createRoutine('FETCH_ACTIVE_CURRENCIES');
export const fetchCurrencyDefinitions = createRoutine(
  'FETCH_CURRENCY_DEFINITIONS'
);
export const fetchMonthlyExchangeRates = createRoutine(
  'FETCH_MONTHLY_EXCHANGE_RATES'
);
export const updateDefaultCurrency = createRoutine('UPDATE_DEFAULT_CURRENCY');
export const updateDisplayCurrency = createRoutine('UPDATE_DISPLAY_CURRENCY');
export const postExchangeRates = createRoutine('POST_EXCHANGE_RATES');
export const addCurrencyTypes = createRoutine('ADD_CURRENCY_TYPES');

// life cycles
export const fetchLifecycleStages = createRoutine('FETCH_LIFECYCLE_STAGES');
export const fetchLifecycleStageSystemUsage = createRoutine(
  'FETCH_LIFECYCLE_STAGE_SYSTEM_USAGE'
);
export const setDefaultLifecycleStage = createRoutine(
  'SET_DEFAULT_LIFECYCLE_STAGE'
);
export const addLifecycleStage = createRoutine('ADD_LIFECYCLE_STAGE');
export const deleteLifecycleStage = createRoutine('DELETE_LIFECYCLE_STAGE');
export const reorderLifecycleStage = createRoutine('REORDER_LIFECYCLE_STAGE');
export const renameLifecycleStage = createRoutine('RENAME_LIFECYCLE_STAGE');

export const fetchSummaryCollapseStatus = createRoutine(
  'FETCH_SUMMARY_COLLAPSE_STATUS'
);
export const saveSummaryCollapseStatus = createRoutine(
  'SAVE_SUMMARY_COLLAPSE_STATUS'
);

export const toggleMoveLinkedEntityForm = createRoutine(
  'TOGGLE_MOVE_LINKED_ENTITY_FORM'
);
export const toggleMoveEntityForm = createRoutine('TOGGLE_MOVE_ENTITY_FORM');
export const moveLinkedEntities = createRoutine('MOVE_LINKED_ENTITIES');
export const moveEntity = createRoutine('MOVE_ENTITY');

// image upload
export const uploadProfileImage = createRoutine('UPDATE_PROFILE_IMAGE');

export const uploadPublicImage = createRoutine('UPLOAD_PUBLIC_IMAGE');

export const fetchEntityChangeLog = createRoutine('FETCH_ENTITY_CHANGELOG');

export const resetEntityChangeLog = createRoutine('RESET_ENTITY_CHANGELOG');

// initialization actions
export const initialization = createRoutine('INITIALIZATION');

// global preset
export const fetchGlobalPreSetData = createRoutine('FETCH_GLOBAL_PRESET_DATA');

// partial list V2
export const getPartialInitialOrganizationList = createRoutine(
  'FETCH_PARTIAL_INITIAL_ORGANIZATION_LIST'
);
export const getPartialInitialAccountList = createRoutine(
  'FETCH_PARTIAL_INITIAL_ACCOUNT_LIST'
);
export const getPartialInitialContactList = createRoutine(
  'FETCH_PARTIAL_INITIAL_CONTACT_LIST'
);
export const getPartialQueryOrganizationList = createRoutine(
  'FETCH_PARTIAL_QUERY_ORGANIZATION_LIST'
);
export const getPartialQueryAccountList = createRoutine(
  'FETCH_PARTIAL_QUERY_ACCOUNT_LIST'
);
export const getPartialQueryContactList = createRoutine(
  'FETCH_PARTIAL_QUERY_CONTACT_LIST'
);
